import { Anchor } from '@components/Anchor';
import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IConsumoInternetFilter, IConsumoInternetRecord } from '@services/RelatorioService';
import React from 'react';

export type ConsumoInternetTableProps = {
    data: IData<IConsumoInternetRecord, IConsumoInternetFilter>
    isLoading: boolean
    detalhesModal: IModalWindow
    onCsvButtonClick: VoidFunction
}

export function ConsumoInternetTable ({ data, isLoading, detalhesModal, onCsvButtonClick }: ConsumoInternetTableProps) {
    const formatter = useFormatter();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="linhaId">ID</TableSortCell>
                        <TableSortCell fieldName="numeroSemMascara">Número</TableSortCell>
                        <TableSortCell fieldName="clienteNome">Cliente</TableSortCell>
                        <TableSortCell fieldName="numeroContrato">Nº Contrato</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraEmpresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraOperadoraNome">Operadora</TableSortCell>
                        <TableSortCell fieldName="consumo">Consumo</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((consumoInternet, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{consumoInternet.linhaId}</TableKeyCell>
                                    <TableCell>{formatter.toCelular(consumoInternet.numeroSemMascara)}</TableCell>
                                    <TableCell>{consumoInternet.clienteId !== undefined ? <LinkText to={`/cliente/${consumoInternet.clienteId}`} text={consumoInternet.clienteNome} /> : ""}</TableCell>
                                    <TableCell>{consumoInternet.numeroContrato}</TableCell>
                                    <TableCell>{consumoInternet.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{consumoInternet.contratoOperadoraOperadoraNome}</TableCell>
                                    <TableCell><Anchor onClick={data.handleRowFocused(consumoInternet, detalhesModal.open)}>{formatter.toFloat(consumoInternet.consumo / 1024 / 1024)} GB</Anchor></TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}